import styled from "styled-components";
import { Link as LinkR } from "react-router-dom";
import { FaTimes } from "react-icons/fa";

export const SidebarContainer = styled.aside`
  position: fixed;
  z-index: 9999;
  inset: 0;

  width: 100vw;
  height: 100dvh;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 18px;

  background: rgba(0, 0, 0, 0.72);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);

  opacity: ${({ isOpen }) => (isOpen ? "1" : "0")};
  pointer-events: ${({ isOpen }) => (isOpen ? "auto" : "none")};
  transform: ${({ isOpen }) =>
    isOpen ? "translateY(0)" : "translateY(-8px)"};

  transition: opacity 0.22s ease, transform 0.22s ease;

  overflow: hidden;
  overflow-x: hidden;
  overscroll-behavior: contain;

  &, * {
    box-sizing: border-box;
  }

  @media screen and (max-width: 480px) {
    padding: 14px;
  }
`;

export const CloseIcon = styled(FaTimes)`
  color: rgba(255, 255, 255, 0.94);
  font-size: 18px;
`;

export const Icon = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;

  width: 44px;
  height: 44px;
  border-radius: 14px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);

  cursor: pointer;
  transition: transform 0.15s ease, background 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.14);
  }

  &:active {
    transform: scale(0.96);
  }

  @media screen and (max-width: 360px) {
    width: 40px;
    height: 40px;
    border-radius: 12px;
  }
`;

export const SidebarWrapper = styled.div`
  position: relative;
  margin: 0 auto;

  width: min(460px, 100%);
  border-radius: 22px;

  padding: 18px 16px;

  background: linear-gradient(
    180deg,
    rgba(8, 8, 10, 0.96),
    rgba(0, 0, 0, 0.9)
  );
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 28px 70px rgba(0, 0, 0, 0.6);

  max-height: calc(
    100dvh - 36px - env(safe-area-inset-top) - env(safe-area-inset-bottom)
  );
  overflow: hidden;

  display: flex;
  flex-direction: column;

  @media screen and (max-width: 480px) {
    width: 100%;
    border-radius: 18px;
    padding: 14px 12px;
  }
`;

export const SidebarBody = styled.div`
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  padding: 6px 2px 2px 2px;
  overscroll-behavior: contain;
`;

export const SidebarHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  padding: 6px 6px 12px 6px;
  padding-right: 58px;

  @media screen and (max-width: 360px) {
    padding-right: 52px;
  }
`;

export const SidebarBrand = styled(LinkR)`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  padding: 6px 8px;
  border-radius: 14px;

  text-decoration: none;
  cursor: pointer;

  transition: background 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.06);
  }
`;

export const SidebarLogoImg = styled.img`
  height: 74px;
  width: auto;
  display: block;
  object-fit: contain;

  filter: drop-shadow(0 10px 18px rgba(0, 0, 0, 0.35));

  @media screen and (max-width: 480px) {
    height: 64px;
  }

  @media screen and (max-width: 360px) {
    height: 58px;
  }
`;

export const SidebarMenu = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const SidebarLinkR = styled(LinkR)`
  display: flex;
  align-items: center;
  justify-content: center;

  min-height: 54px;
  padding: 0 14px;
  border-radius: 16px;

  color: rgba(255, 255, 255, 0.94);
  text-decoration: none;
  font-size: 16px;
  font-weight: 900;
  letter-spacing: 0.2px;
  text-align: center;

  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);

  transition:
    transform 0.15s ease,
    background 0.2s ease,
    color 0.2s ease,
    border 0.2s ease;

  &:hover {
    background: rgba(212, 175, 55, 0.12);
    border: 1px solid rgba(212, 175, 55, 0.24);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  @media screen and (max-width: 480px) {
    min-height: 48px;
    border-radius: 14px;
    font-size: 15px;
  }

  @media screen and (max-width: 360px) {
    min-height: 46px;
    font-size: 14px;
  }
`;

export const Divider = styled.div`
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin: 12px 0 10px 0;
`;

export const SidebarBtnWrap = styled.div`
  margin-top: 6px;
  display: flex;
  justify-content: center;
`;

export const SidebarButton = styled(LinkR)`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  min-height: 48px;
  padding: 0 18px;
  border-radius: 999px;

  font-size: 15px;
  font-weight: 900;
  text-decoration: none;
  white-space: nowrap;

  cursor: pointer;

  background: ${({ $danger }) =>
    $danger
      ? "rgba(239,68,68,0.92)"
      : "linear-gradient(135deg, rgba(0,103,114,0.96), rgba(212,175,55,0.88))"};

  border: 1px solid rgba(255, 255, 255, 0.14);
  color: #fff;

  box-shadow: 0 16px 34px rgba(0, 0, 0, 0.45);

  transition:
    transform 0.15s ease,
    background 0.2s ease,
    color 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.95);
    color: #0b0f14;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0px);
  }

  @media screen and (max-width: 360px) {
    min-height: 46px;
    font-size: 14px;
  }
`;